if ( typeof CartForm !== 'function' ) {
	class CartForm extends HTMLElement {

		constructor(){
			super();
			this.ajaxifyCartItems();
		}

		ajaxifyCartItems(){

			this.form = this.querySelector('form');

			this.querySelectorAll('[data-js-cart-item]').forEach(item=>{

				const remove = item.querySelector('.remove');
				if ( remove ) {
					remove.dataset.href = remove.getAttribute('href');
					remove.setAttribute('href', '');
					remove.addEventListener('click', (e)=>{
						e.preventDefault();
						this.updateCartQty(item, 0);
					})
				}

				const qty = item.querySelector('.qty');
				if ( qty ) {
					qty.addEventListener('input', debounce(e=>{
						e.preventDefault();
						e.target.blur();
						this.updateCartQty(item, parseInt(qty.value));
					}, 500));
					qty.addEventListener('click', (e)=>{
						e.target.select();
					})
				}

			})

		}

		updateCartQty(item, newQty){

			let alert = null;

			this.form.classList.add('processing');
			if ( this.querySelector('.alert') ) {
				this.querySelector('.alert').remove();
			}

			const body = JSON.stringify({
				line: parseInt(item.dataset.line),
				quantity: newQty
			});

			fetch(KROWN.settings.routes.cart_change_url, {
					method: 'POST',
					headers: { 'Content-Type': 'application/json', 'Accept': 'application/javascript' },
					body
				})
				.then(response => response.json())
				.then(response => {
					if ( response.status == 422 ) {
						// wrong stock logic alert
						alert = document.createElement('span');
						alert.classList.add('alert', 'alert--error');
						if ( typeof response.description === 'string' ) {
							alert.innerHTML = response.description;
						} else {
							alert.innerHTML = response.message;
						}
					}
					return fetch('?section_id=helper-cart');
				})
				.then(response => response.text())
				.then(text => {

					const sectionInnerHTML = new DOMParser().parseFromString(text, 'text/html');
					const cartFormInnerHTML = sectionInnerHTML.getElementById('AjaxCartForm').innerHTML;
					const cartSubtotalInnerHTML = sectionInnerHTML.getElementById('AjaxCartSubtotal').innerHTML;

					const cartItems = document.getElementById('AjaxCartForm');
					cartItems.innerHTML = cartFormInnerHTML;
					cartItems.ajaxifyCartItems();

					document.querySelectorAll('[data-header-cart-count]').forEach(elm=>{
						elm.textContent = cartItems.querySelector('[data-cart-count]').textContent;
					});
					document.querySelectorAll('[data-header-cart-total').forEach(elm=>{
						elm.textContent = cartItems.querySelector('[data-cart-total]').textContent;
					});

					if ( alert !== null ) {
						this.form.prepend(alert);
					} 

					document.getElementById('AjaxCartSubtotal').innerHTML = cartSubtotalInnerHTML;
							
					const event = new Event('cart-updated');
					this.dispatchEvent(event);

				})
				.catch(e => {
					console.log(e);
					let alert = document.createElement('span');
					alert.classList.add('alert', 'alert--error');
					alert.textContent = KROWN.settings.locales.cart_general_error;
					this.form.prepend(alert);
				})
				.finally(() => {
					this.form.classList.remove('processing');
				});
		}

	} 


  if ( typeof customElements.get('cart-form') == 'undefined' ) {
		customElements.define('cart-form', CartForm);
	}

}

if ( typeof CartProductQuantity !== 'function' ) {

	class CartProductQuantity extends HTMLElement {
		constructor(){
			super();
			this.querySelector('.qty-minus').addEventListener('click', this.changeCartInput.bind(this));
			this.querySelector('.qty-plus').addEventListener('click', this.changeCartInput.bind(this));
		}
		changeCartInput(){
			setTimeout(()=>{
				document.getElementById('AjaxCartForm').updateCartQty(this.closest('[data-js-cart-item]'), parseInt(this.querySelector('.qty').value));
			}, 50);
		}
	}

  if ( typeof customElements.get('cart-product-quantity') == 'undefined' ) {
		customElements.define('cart-product-quantity', CartProductQuantity);
	}

}

// method for apps to tap into and refresh the cart

if ( ! window.refreshCart ) {

	window.refreshCart = () => {
		
		fetch('?section_id=helper-cart')
			.then(response => response.text())
			.then(text => {

			const sectionInnerHTML = new DOMParser().parseFromString(text, 'text/html');
			const cartFormInnerHTML = sectionInnerHTML.getElementById('AjaxCartForm').innerHTML;
			const cartSubtotalInnerHTML = sectionInnerHTML.getElementById('AjaxCartSubtotal').innerHTML;

			const cartItems = document.getElementById('AjaxCartForm');
			cartItems.innerHTML = cartFormInnerHTML;
			cartItems.ajaxifyCartItems();

			document.querySelectorAll('[data-header-cart-count]').forEach(elm=>{
				elm.textContent = cartItems.querySelector('[data-cart-count]').textContent;
			});
			document.querySelectorAll('[data-header-cart-total').forEach(elm=>{
				elm.textContent = cartItems.querySelector('[data-cart-total]').textContent;
			})
			
			document.getElementById('AjaxCartSubtotal').innerHTML = cartSubtotalInnerHTML;
			if ( document.querySelector('[data-js-site-cart-sidebar]') ) {
				document.querySelector('[data-js-site-cart-sidebar]').show();
			}

			if ( document.querySelector('cart-recommendations') ) {
				document.querySelector('cart-recommendations').innerHTML = '';
				document.querySelector('cart-recommendations').generateRecommendations();
			}

		})

	}

}

if ( ! customElements.get('cart-note') ) {
  customElements.define(
    'cart-note',
    class CartNote extends HTMLElement {
      constructor() {
        super();
        this.addEventListener(
          'input',
          debounce(event => {
            const body = JSON.stringify({ note: event.target.value });
            fetch(`${KROWN.settings.routes.cart_update_url}`, { 
							method: 'POST',
							headers: { 'Content-Type': 'application/json', 'Accept': 'application/javascript' },
							body 
						});
		  		}, 150)
				);
      }
    }
  );
}

// Cart Quantity Logic (matches product page behavior)
document.addEventListener('DOMContentLoaded', function() {
  document.querySelectorAll('[data-cart-quantity-input]').forEach(input => {
    const lineIndex = input.dataset.line;
    const messageEl = document.querySelector(`[data-cart-quantity-message][data-line="${lineIndex}"]`);
    const minusBtn = document.querySelector(`[data-cart-quantity-minus][data-line="${lineIndex}"]`);
    const plusBtn = document.querySelector(`[data-cart-quantity-plus][data-line="${lineIndex}"]`);

    function showMessage(text) {
      if (messageEl) {
        messageEl.textContent = text;
        messageEl.style.display = 'block';
        setTimeout(() => {
          messageEl.style.display = 'none';
        }, 3000);
      }
    }

    function updateButtons() {
      const value = parseInt(input.value);
      const min = parseInt(input.min);
      const max = parseInt(input.max);

      if (minusBtn) {
        minusBtn.disabled = value <= min;
        minusBtn.style.opacity = value <= min ? 0.5 : 1;
        minusBtn.style.cursor = value <= min ? 'not-allowed' : 'pointer';
      }

      if (plusBtn) {
        plusBtn.disabled = value >= max;
        plusBtn.style.opacity = value >= max ? 0.5 : 1;
        plusBtn.style.cursor = value >= max ? 'not-allowed' : 'pointer';
      }
    }

    // Minus Button Handler
    if (minusBtn) {
      minusBtn.addEventListener('click', function(e) {
        e.preventDefault();
        const step = parseInt(input.step) || 1;
        const newValue = parseInt(input.value) - step;
        
        if (newValue >= parseInt(input.min)) {
          input.value = newValue;
          updateButtons();
          input.dispatchEvent(new Event('change'));
        }
      });
    }

    // Plus Button Handler
    if (plusBtn) {
      plusBtn.addEventListener('click', function(e) {
        e.preventDefault();
        const step = parseInt(input.step) || 1;
        const newValue = parseInt(input.value) + step;
        const max = parseInt(input.max);
        
        if (newValue > max) {
          showMessage(`Maximum quantity is ${max}`);
          input.value = max;
        } else {
          input.value = newValue;
        }
        updateButtons();
        input.dispatchEvent(new Event('change'));
      });
    }

    // Input Validation
    input.addEventListener('change', function() {
      const min = parseInt(input.min);
      const max = parseInt(input.max);
      const step = parseInt(input.step) || 1;
      let value = parseInt(input.value) || min;
      
      if (isNaN(value)) value = min;
      
      if (value < min) {
        value = min;
      } else if (value > max) {
        value = max;
        showMessage(`Maximum quantity is ${max}`);
      }
      
      if (step > 1 && value % step !== 0) {
        value = Math.round(value / step) * step;
        showMessage(`Please order in multiples of ${step}`);
      }
      
      input.value = value;
      updateButtons();
    });

    updateButtons(); // Initial button state
  });
});

